import React from "react";
import { Link } from "react-router-dom";

/**
 * Section title with an optional link to the full list. The heading sits on a
 * full-width rule (the shirorekha).
 */
export const SectionHeading = ({ title, to, linkLabel, as: Tag = "h2" }) => (
  <div className="mb-5 flex items-end justify-between gap-4 shirorekha pb-2">
    <Tag className="text-[1.6rem] sm:text-[2rem]">{title}</Tag>
    {to && (
      <Link to={to} className="shrink-0 pb-1 text-[0.95rem] text-primary underline-offset-4 hover:underline">
        {linkLabel}
      </Link>
    )}
  </div>
);
